/* eslint-disable */
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import aa from 'search-insights';

import {
  searchBox,
  hits,
  refinementList,
  hierarchicalMenu,
  pagination,
  panel,
  stats,
  sortBy,
} from 'instantsearch.js/es/widgets';

const KB_INDEX = import.meta.env.VITE_ALGOLIA_KB_INDEX || 'DEV_KENNISBANK';

aa('init', {
  appId: '9LUABNZU72',
  apiKey: 'b722874de5f990663e8cb60fc39e5e41',
});

const searchClient = algoliasearch(
  '9LUABNZU72',
  'b722874de5f990663e8cb60fc39e5e41'
);

const search = instantsearch({
  indexName: KB_INDEX,
  searchClient,
  numberLocale: 'nl',
  insights: true,
  routing: {
    stateMapping: {
      stateToRoute: function (uiState) {
        const indexUiState = uiState[KB_INDEX];
        return {
          q: indexUiState.query,
          type: indexUiState.refinementList && indexUiState.refinementList.type,
          theme: indexUiState.hierarchicalMenu && indexUiState.hierarchicalMenu['theme.lvl0']
        };
      },
      routeToState: function (routeState) {
        return {
          [KB_INDEX]: {
            query: routeState.q,
            refinementList: {
              type: routeState.type
            },
            hierarchicalMenu: {
              'theme.lvl0': routeState.theme
            }
          },
        };
      },
    },
  },
  future: {
    preserveSharedStateOnUnmount: true,
  },
});

if (document.getElementById('sort-by')) {
  search.addWidgets([
    sortBy({
      container: '#sort-by',
      cssClasses: {
        select: 'w-auto form-select',
      },
      items: [
        { label: 'Relevantie', value: KB_INDEX },
        { label: 'Datum', value: `${KB_INDEX}_DATE_DESC` },
      ],
    }),
  ]);
}

if(document.getElementById('searchbox')) {

  const placeholderText = () => {
    const searchboxElement = document.getElementById('searchbox');
    if (searchboxElement && searchboxElement.hasAttribute('data-ais-placeholder')) {
      return searchboxElement.getAttribute('data-ais-placeholder');
    }
    return 'Waar ben je naar op zoek in de kennisbank?';
  };

  search.addWidgets([searchBox({
    container: '#searchbox',
    placeholder: placeholderText(),
    showReset: false,
    showSubmit: true,
    cssClasses: {
      input: 'form-control form-control-lg'
    },
    templates: {
      loadingIndicator({cssClasses}, {html}) {
        return html`<span class="${cssClasses.loadingIndicator}">loading</span>`;
      },
    },
  })]);
}

if(document.getElementById('filtersearchbox')) {

  const filterSearchPanel = panel({
    templates: {
      header: 'Zoeken',
    },
    cssClasses: {
      root: 'mb-5',
      header: 'mb-3 fw-bold'
    }
  })(searchBox);

  search.addWidgets([
    filterSearchPanel({
      container: '#filtersearchbox',
      placeholder: '',
      showReset: false,
      showSubmit: true,
      placeholder: 'Zoek binnen de resultaten',
      cssClasses: {
        form: 'input-group mb-3',
        input: 'form-control',
        submit: 'btn btn-green rounded-end',
      },
      templates: {
        loadingIndicator({cssClasses}, {html}) {
          return html`<span class="${cssClasses.loadingIndicator}">loading</span>`;
        },
      },
    })
  ]);
}

if(document.getElementById('stats')) {
  search.addWidgets([stats({
      container: '#stats',
      templates: {
        text(data, { html }) {
          let count = '';
          const query = data.query;

          if(data.hasNoResults) {
            return html`<span class="fs-5 fw-bold">Geen resultaten gevonden.</span>`
          }

          if (data.hasManyResults) {
            count += `${data.nbHits} resultaten`;
          } else if (data.hasOneResult) {
            count += `1 resultaat`;
          } else {
            count += `Geen resultaten`;
          }

          return query
            ? html`<span class="fs-5 fw-bold">${count} gevonden voor <q class="text-primary">${query}</q>.</span>`
            : html`<span class="fs-5 fw-bold">${count} gevonden.</span>`;
        },
      },
    })
  ]);
}

if(document.getElementById('type')) {

  const typesPanel = panel({
    templates: {
      header: 'Type',
    },
    hidden(options) {
      return options.results.nbHits === 0;
    },
    cssClasses: {
      root: 'mb-5',
      header: 'mb-3 fw-bold'
    }
  })(refinementList);

  search.addWidgets([
    typesPanel({
      container: '#type',
      attribute: 'type',
      searchablePlaceholder: '',
      limit: 25,
      sortBy: ['name:asc'],
      cssClasses: {
        list: 'list-unstyled',
        item: 'my-2 form-check',
        label: 'form-check-label d-flex pe-3',
        labelText: 'flex-grow-1',
        checkbox: 'form-check-input me-2',
        count: ['badge', 'text-bg-primary-light', 'ms-2'],
      }
    })
  ])
};

if(document.getElementById('theme')) {

  const themesPanel = panel({
    templates: {
      header: 'Thema\'s',
    },
    hidden(options) {
      return options.results.nbHits === 0;
    },
    cssClasses: {
      root: 'mb-5',
      header: 'mb-3 fw-bold'
    }
  })(hierarchicalMenu)

  search.addWidgets([
    themesPanel({
      container: '#theme',
      attributes: [
        'theme.lvl0',
        'theme.lvl1',
        'theme.lvl2',
      ],
      limit: 15,
      sortBy: ['name'],
      cssClasses: {
        list: ['nav', 'flex-column'],
        childList: ['nav', 'flex-column', 'ps-3'],
        item: 'nav-item',
        link: ['nav-link', 'w-100'],
        count: ['d-none', 'badge', 'text-bg-primary-light', 'ms-2'],
        label: ['flex-grow-1'],
        selectedItemLink: 'active'
      },
      templates: {
        item(data, {html}) {
          return html`
            <a class="${data.cssClasses.link}" href="${data.url}">
              <span class="${data.cssClasses.label}">${data.label}</span>
              <span class="${data.cssClasses.count}">${data.count.toLocaleString()}</span>
            </a>
          `;
        },
      }
    })
  ]);

}
if(document.getElementById('subtheme')) {

  const rootTheme = () => {
    const themeElement = document.getElementById('subtheme');
    if (themeElement && themeElement.hasAttribute('data-ais-theme')) {
      return themeElement.getAttribute('data-ais-theme');
    }
    return null;
  };

  const themesPanel = panel({
    templates: {
      header: 'Filter op onderwerp',
    },
    hidden(options) {
      return options.results.nbHits === 0;
    },
    cssClasses: {
      root: 'mb-5',
      header: 'mb-3 fw-bold'
    }
  })(hierarchicalMenu)

  search.addWidgets([
    themesPanel({
      container: '#subtheme',
      attributes: [
        'theme.lvl0',
        'theme.lvl1',
        'theme.lvl2',
      ],
      limit: 10,
      sortBy: ['name'],
      rootPath: rootTheme(),
      showMore: true,
      showMoreLimit: 25,
      cssClasses: {
        list: ['nav', 'flex-column'],
        childList: ['nav', 'flex-column', 'ps-3'],
        item: 'nav-item',
        link: ['nav-link', 'w-100', 'd-flex', 'align-items-center', 'justify-content-between'],
        count: ['badge', 'text-bg-primary-light', 'ms-2'],
        label: ['flex-grow-1'],
        selectedItemLink: 'active',
        showMore: ['btn','btn-sm' ,'btn-outline-primary', 'mt-3'],
        disabledShowMore: ['d-none']
      },
      templates: {
        item(data, {html}) {
          return html`
            <a class="${data.cssClasses.link}" href="${data.url}">
              <span class="${data.cssClasses.label}">${data.label}</span>
              <span class="${data.cssClasses.count}">${data.count.toLocaleString()}</span>
            </a>
          `;
        },
        showMoreText(data, { html }) {
          return html`<span>${data.isShowingMore ? 'Minder opties' : 'Meer opties'}</span>`;
        },
      }
    })
  ]);

}

if(document.getElementById('results')) {
  search.addWidgets([
    hits({
      container: '#results',
      cssClasses: {
        item: 'mb-3',
        disabledLoadMore: 'hidden'
      },
      templates: {
        item: function (hit, {html, components}) {
          return html`
            <div class="card p-3 p-lg-4 h-100 ${(hit.type == 'Webpagina') ? 'card--webpage ' : 'card--kb-article'}">
              <div class="card-body d-flex align-items-start justify-content-between p-0 pb-2">
                <h5 class="card__title display-4">
                  <a
                    href="${hit.url}"
                    target="${(hit.type == 'Webpagina') ? '_blank' : '_self'}"
                    class="d-block text-reset text-decoration-none">${ components.Highlight({ attribute: 'title', hit }) }</a>
                </h5>
                <span class="badge text-primary">${hit.postDate.replace(/(\d{4})(\d{2})(\d{2})/, "$3-$2-$1")}</span>
              </div>
              <div class="card-intro m-0">
                <p>${ components.Highlight({ attribute: 'introduction', hit }) ?? components.Highlight({ attribute: 'bodybuilder', hit }) }</p>
              </div>
              <div class="card-footer read-more bg-transparent border-top mt-3 px-0 pb-0 pt-2 pt-lg-3 d-flex flex-wrap">
                ${hit.theme?.lvl0?.map((theme, index) => html`
                  <span class="text-muted text-decoration-none">${theme}</span>
                  ${index < hit.theme.lvl0.length - 1 ? html`<span class="mx-2 text-muted">|</span>` : ''}
                `)}
                ${ (hit.theme?.lvl0?.length) ? html`<span class="mx-2 text-muted" > | </span>` : ''}
                <span><span class="text-muted text-decoration-none">${hit.type[0]}</span></span>
              </div>
            </div>
          `
        },
        empty(results, {html}) {
          return html` `;
        },
      }
    }),
    pagination({
      container: '#pagination',
      showFirst: false,
      showPrevious: false,
      showNext: false,
      showLast: false,
      padding: 2,
      cssClasses: {
        list: 'pagination',
        item: 'page-item',
        link: 'page-link',
        selectedItem: 'disabled',
      },
    })
  ])
}

search.start();
